<template>
  <v-content>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view style="margin-top: -60px;" />
      </v-fade-transition>
    </div>
    <core-footer v-if="$route.name !== 'Maps'" />
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: '后台管理系统'
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
